export default "__VITE_ASSET__8cba7b8a__"